import { useRouter } from "next/router";
import {
  Box,
  Text,
  Link,
  List,
  ListItem,
  Checkbox,
  Button,
  Image,
  Center,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";

import React, { useState, useEffect, useCallback } from "react";
import BaseLayout from "../../components/base_layout";
import styles from "../../styles/Home.module.css";
import { description, Goto, period, logo } from "../../components/search";
import Loading from "../../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { lifecycle, GetCookie } from "../../provider/common";
import { NextSeo } from "next-seo";
import Btn from "../../components/common/btn";

// 전역변수
const axios = require("axios").default;
const SEARCH_API_URL = process.env.SEARCH_API_URL;

export default function SearchList() {
  const router = useRouter();

  const { keyword } = router.query;
  const [isShowMaker, setShowMaker] = useState(true);
  const [isShowDistributor, setShowDistributor] = useState(true);
  const [datas, setDatas] = useState([]);
  const [manufacturer, setmMnufacturer] = useState([]);
  const [distributor, setDistributor] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loadingShow, setLoadingShow] = useState(true);
  const [searchShow, setSearchShow] = useState(false);
  const [noneSearchShow, setNoneSearchShow] = useState(false);
  const [searchError, SetsearchError] = useState(false);
  const [filterListManu, setFilterListManu] = useState([]);
  const [filterListSrc, setFilterListSrc] = useState([]);
  const [isLoginCheck, setIsLoginCheck] = useState("");

  useEffect(() => {
    start_search(keyword);
    showSelect();
    handleLoginCheck();
  }, []);

  // 검색시작
  const start_search = async (keyword) => {
    try {
      //기본적으로 키워드를 인코딩 처리해서 날림
      const encodeKeyword = btoa(
        keyword.startsWith("%") ? keyword : encodeURIComponent(keyword)
      );

      // 키워드의 끝에 하나 이상의 스페이스가 있는지 확인하고 제거
      keyword = keyword.trimEnd();

      // 렌더함수
      async function render(result) {
        if (result.data.data.parts) {
          setFilterListManu(result.data.data.filter.manufacturers);
          setFilterListSrc(result.data.data.filter.sources);
          // 렌더링하기 위한 데이터로 가공
          if (result.data.data.parts.length > 0) {
            setLoadingShow(false);

            // 제품 price 정보에 it_id 추가
            result.data.data.parts.map((part) => {
              part.price = part.price
                .filter(
                  (pr) =>
                    pr.source !== "future" &&
                    pr.source !== "corestaff" &&
                    pr.source !== "dfrobot"
                )
                .map((pr) => {
                  let newObj = { ...pr, it_id: part.it_id };
                  return newObj;
                });
            });

            setDatas(result.data.data.parts);
          }
          setLoadingShow(false);
        }
      }

      //======= 필터 적용할때 ===================
      if ("type" in router.query) {
        const { source, manufacturer, pn, sort } = router.query;
        var URL = `${SEARCH_API_URL}/search/${encodeKeyword}?type=filter&source=${source}&manufacturer=${manufacturer}&pn=${pn}&sort=${sort}`;
      } else {
        //======== 필터 적용 안할때 ===================
        var URL = `${SEARCH_API_URL}/search/${encodeKeyword}`;
      }

      // 첫번째 fetch
      let res = await axios.get(URL);
      // 첫번째 렌더링 과정에서 데이터가 끝일때
      if (res.data.msg == "Success") {
        // 데이터가 없으면 결과없는 화면 뜨게하기
        if (res.data.data.parts.length === 0) {
          setNoneSearchShow(true);
          setSearchShow(false);
          setLoadingShow(false);
        } else {
          setNoneSearchShow(false);
          setSearchShow(true);
          render(res);
        }
        return;
      } else {
        // 첫번째 렌더링 진행
        setNoneSearchShow(false);
        setSearchShow(true);
        render(res);
      }
      // 아직 데이터가 남았으면 풀링 실행
      if (res.data.msg == "In Process") {
        var intervalID = setInterval(async function () {
          // 연속 fetch
          let res = await axios.get(URL);

          // 마지막 데이터 처리
          if (res.data.msg == "Success") {
            clearInterval(intervalID);
            // 검색결과 없을때
            if (res.data.data.parts.length === 0) {
              setNoneSearchShow(true);
              setSearchShow(false);
            }
          }
          render(res);
        }, 1500); // 1000 milliseconds = 1 second.
      }
      // 검색 에러 대응
    } catch (e) {
      console.log("Error:", e);

      setLoadingShow(false);
      SetsearchError(true);
      setSearchShow(false);
    }
  };

  // selected 된 항목들 표시 해주기
  const showSelect = () => {
    // selected 된 항목들 표시 해주기
    if ("type" in router.query) {
      const { source, manufacturer } = router.query;
      let selectedSource = source.split(",");
      let selectedManufacturer = manufacturer.split(",");

      //배열에서 값이 ''인것 필터링으로 제거
      selectedSource = selectedSource.filter((e) => e != "");
      selectedManufacturer = selectedManufacturer.filter((e) => e != "");

      if (manufacturer !== "" && source !== "") {
        const selectedArray = [...selectedManufacturer, ...selectedSource];
        setDistributor(selectedSource);
        setmMnufacturer(selectedManufacturer);
        setSelected(selectedArray);
      } else if (manufacturer === "") {
        setDistributor(selectedSource);
        setSelected(selectedSource);
      } else if (source === "") {
        setmMnufacturer(selectedManufacturer);
        setSelected(selectedManufacturer);
      } else {
        setSelected([]);
      }
    } else {
      setSelected([]);
    }
  };

  // checkbox 필터선택 함수
  const handleQuery = useCallback((e) => {
    let checked = e.target.checked;
    let value = e.target.value.split(" ");
    // 체크되어있으면 추가
    if (checked === true) {
      if (value[0] === "manufacturer") {
        setmMnufacturer((current) => current.concat(value.slice(1).join(" ")));
      } else {
        setDistributor((current) => current.concat(value[1]));
      }
      setSelected((current) => current.concat(value.slice(1).join(" ")));
    } else {
      // 체크 해제 것들은 제거
      if (value[0] === "manufacturer") {
        setmMnufacturer((current) =>
          current.filter((e) => e !== value.slice(1).join(" "))
        );
      } else {
        setDistributor((current) => current.filter((e) => e !== value[1]));
      }
      setSelected((current) =>
        current.filter((e) => e !== value.slice(1).join(" "))
      );
    }
  });

  // 정렬 체크( 납기 빠른순, 재고 많은 순)
  const handleOrder = (e) => {
    _handleFilterSearch(e);
  };

  //필터적용 버튼 실행 함수
  const _handleFilterSearch = (e) => {
    // 검색된 현재값
    const current = `/search/lists?keyword=${
      keyword.startsWith("%") ? keyword : encodeURIComponent(keyword)
    }`;

    // 키워드 검색
    if (e == "keyword") {
      window.location.href = `${current}&type=filtered&manufacturer=${manufacturer}&source=${distributor}&pn=${keyword}&sort=day`;
      return;
    }
    // 라디오 버튼을 눌렀을때 반응하는 실행
    if (e == "day" || e == "qty") {
      window.location.href = `${current}&type=filtered&manufacturer=${manufacturer}&source=${distributor}&pn=&sort=${e}`;
    } else {
      // 필터적용 버튼 눌렀을때 실행
      if (router.query.sort) {
        window.location.href = `${current}&type=filtered&manufacturer=${manufacturer}&source=${distributor}&pn=&sort=${router.query.sort}`;
        // 기본값 필터링은 납기순
      } else {
        window.location.href = `${current}&type=filtered&manufacturer=${manufacturer}&source=${distributor}&pn=&sort=day`;
      }
    }
  };

  // 선택초기화 버튼 실행 함수
  const _handleResetSearch = () => {
    const current = `/search/lists?keyword=${
      keyword.startsWith("%") ? keyword : encodeURIComponent(keyword)
    }`;
    window.location.href = `${current}`;
  };

  // 여닫는 함수
  const _handleShowmaker = () => {
    setShowMaker(!isShowMaker);
  };
  const _handleShowDirstributor = () => {
    setShowDistributor(!isShowDistributor);
  };

  const handleClick = async () => {
    alert("견적문의하기는 PC에서 이용해주세요.");
  };
  const handleLoginCheck = async () => {
    const isLogin = await GetCookie("isLogin");
    setIsLoginCheck(isLogin);
  };

  const combineBotAsked = async (data, pics) => {
    if (data.source === "pandaparts") {
      if (isLoginCheck === "0") {
        const href = `/auth/login?before=/parts/inventory/${data.it_id}`;
        router.push(href);
        return;
      }

      if (isLoginCheck === "1") {
        router.push(`/parts/inventory/${data.it_id}`);
        return;
      }
    }
    // const axios = require("axios").default;
    // 로그인이 되어있으면 견적바구니로 바로 요청
    if (isLoginCheck === "1") {
      const body = [];

      body.push({
        it_id: data.it_id,
        it_brand: data.manufacturer,
        it_name: data.pn,
        it_maker: data.source,
        qty: pics.stock,
      });

      try {
        const URL = process.env.PANDA_API_URL + "/api/mall/insertQuoteLists";
        const result = await axios.post(URL, body, {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${await GetCookie("token")}`,
          },
        });
        if (result.data.status === 200) {
          if (
            confirm(
              "견적바구니에 저장되었습니다. 견적바구니로 이동하시겠습니까?"
            ) === true
          ) {
            router.push(`/marketplace/cart`);
            return;
          }
        } else {
          alert("견적바구니에 저장이 실패하였습니다.");
        }
      } catch (e) {
        alert("견적바구니에 저장이 실패하였습니다");
      }
    } else {
      const basePath = `/search/lists?keyword=${keyword}`;
      const href = `/auth/login?before=${basePath}`;
      router.push(href);
    }
    // 미 로그인 되어있으면 로그인 화면으로 간다.
  };

  return (
    <>
      <NextSeo
        title={
          keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " - 실시간 재고 검색"
        }
        description={
          keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " 가격비교, 재고확인, 데이터시트, 전자부품 쇼핑몰"
        }
        canonical={
          process.env.PANDA_LIVE_URL +
          "/search/lists?keyword=" +
          keyword.startsWith("%")
            ? keyword
            : encodeURIComponent(keyword)
        }
        openGraph={{
          title: keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " - 실시간 재고 검색",
          description: keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " 가격비교, 재고확인, 데이터시트, 전자부품 쇼핑몰",

          url:
            process.env.PANDA_LIVE_URL +
            "/search/lists?keyword=" +
            keyword.startsWith("%")
              ? keyword
              : encodeURIComponent(keyword),
        }}
      />
      <BaseLayout>
        <Loading loadingShow={loadingShow} />
        <Box className={styles.container}>
          {/* ============ 검색결과 데이터가 있을때  ============*/}
          <Box className={searchShow ? "search" : "search-hidden"}>
            <Box className="search-filter">
              <Box className="search-filter-box">
                <Box className="search__filter-title flex-center">제조사</Box>
                <List
                  className={
                    "search__filter-list " +
                    (isShowMaker
                      ? "search-filter__overflow-hidden"
                      : "search-filter__overflow-show")
                  }
                >
                  {filterListManu.length > 0
                    ? filterListManu.map((e) => (
                        <ListItem className="search__filter-listItem flex-center">
                          <Box className="search__filter-listItem-grid">
                            {selected.includes(e) ? (
                              <Checkbox
                                className="search__filter-checkbox"
                                value={`manufacturer ${e}`}
                                onChange={handleQuery}
                                defaultIsChecked
                              />
                            ) : (
                              <Checkbox
                                className="search__filter-checkbox"
                                value={`manufacturer ${e}`}
                                onChange={handleQuery}
                              />
                            )}
                            <Text>{e}</Text>
                          </Box>
                        </ListItem>
                      ))
                    : ""}
                </List>
                {filterListManu.length > 5 ? (
                  isShowMaker ? (
                    <Box
                      onClick={_handleShowmaker}
                      className="search-filter-box_count flex-center"
                    >
                      <Text color="red" fontSize={14} fontWeight={"bold"}>
                        더보기+
                      </Text>
                    </Box>
                  ) : (
                    <Box
                      onClick={_handleShowmaker}
                      className="search-filter-box_count flex-center"
                      color="#E81507"
                      fontSize={14}
                      fontWeight={"bold"}
                    >
                      닫기
                    </Box>
                  )
                ) : (
                  <Box className="search-filter-box_count-none  flex-center" />
                )}
              </Box>
              <Box className="search-filter-box">
                <Box className="search__filter-title  flex-center">유통사</Box>
                <List
                  className={
                    "search__filter-list " +
                    (isShowDistributor
                      ? "search-filter__overflow-hidden"
                      : "search-filter__overflow-show")
                  }
                >
                  {filterListSrc.length > 0
                    ? filterListSrc.map((e) => (
                        <ListItem className="search__filter-listItem flex-center">
                          <Box className="search__filter-listItem-grid">
                            {selected.includes(e) ? (
                              <Checkbox
                                className="search__filter-checkbox"
                                value={`distributor ${e}`}
                                onChange={handleQuery}
                                defaultChecked
                              />
                            ) : (
                              <Checkbox
                                className="search__filter-checkbox"
                                value={`distributor ${e}`}
                                onChange={handleQuery}
                              />
                            )}
                            <Text>{e}</Text>
                          </Box>
                        </ListItem>
                      ))
                    : ""}
                </List>
                {filterListSrc.length > 5 ? (
                  isShowDistributor ? (
                    <Box
                      onClick={_handleShowDirstributor}
                      className="search-filter-box_count flex-center"
                      color="red"
                      fontSize={14}
                      fontWeight={"bold"}
                    >
                      더보기+
                    </Box>
                  ) : (
                    <Box
                      onClick={_handleShowDirstributor}
                      className="search-filter-box_count  flex-center"
                      color="#E81507"
                      fontSize={14}
                      fontWeight={"bold"}
                    >
                      닫기
                    </Box>
                  )
                ) : (
                  <Box className="search-filter-box_count-none  flex-center" />
                )}
              </Box>
              <Box className="search-filter-select">
                <Box textAlign="center">
                  <Btn
                    text="선택초기화"
                    classProp="search__filter-reset"
                    backgroundColor="gray"
                    borderRadius="100px"
                    clickEvent={_handleResetSearch}
                  />
                </Box>
                <List className="search__filter-select-list">
                  {selected.length > 0
                    ? selected.map((e) => (
                        <ListItem className="search__filter-listItem flex-center">
                          <Text color="red">{e}</Text>
                        </ListItem>
                      ))
                    : ""}
                </List>
                <Btn
                  text="필터적용"
                  classProp="search-filter-box__selected-btn flex-center"
                  borderRadius="100px"
                  clickEvent={_handleFilterSearch}
                />
              </Box>
            </Box>

            {/*=======*=======*============== 데이터 검색결과 =======*=======*==============*/}

            <Box className="search-main">
              <Box className="search-list__header">
                <Box className="search-list__header__box flex-around">
                  <RadioGroup
                    onChange={handleOrder}
                    value={router.query.pn ? "keyword" : router.query.sort}
                    paddingRight="160px"
                    width="450px"
                    className="search-list__radio flex-between"
                  >
                    <Radio value="day">납기순</Radio>
                    <Radio value="qty">재고순</Radio>
                    <Radio value="keyword">검색어만 보기</Radio>
                  </RadioGroup>
                </Box>
                <Box className="search-blank" />
              </Box>
              <List>
                {datas.length > 0 ? (
                  datas.map((data) =>
                    data.price.length > 0 ? (
                      <ListItem className="search-list__data">
                        <Box className="search-list__content flex-between">
                          <Box className="search-list__product flex-between">
                            <Image
                              src={data.image_origin || "/images/no_img.png"} // null, undefined 체크
                              onError={(e) => {
                                e.target.src = "/images/no_img.png"; // 404 등 로드 실패 체크
                              }}
                              className="search-list__img"
                            />
                            <Box className="search-list__produc search-list__content-info">
                              <Box className="search-list__content-info__up">
                                <Text fontSize="12px" color="gray">
                                  {data.manufacturername_str}
                                </Text>
                                <Text fontSize="16px">{data.pn}</Text>
                              </Box>
                              {data.source === "pandaparts" ? (
                                ""
                              ) : (
                                <Text>{lifecycle(data.LC)}</Text>
                              )}{" "}
                              <Text>{description(data)}</Text>
                            </Box>
                          </Box>
                          <Box className="search-list_content-dataSheetBox search-list__product">
                            <Box className="search-list__contents-provider">
                              <Text color="gray" paddingRight="5px">
                                컨텐츠 제공:
                              </Text>
                              <Text color="black">{data.source}</Text>
                            </Box>
                            {data.datasheet ? (
                              <Link href={data.datasheet} isExternal={true}>
                                <Box className="datasheet flex-center search-list__produc">
                                  <FontAwesomeIcon
                                    className="datasheet_icon"
                                    icon={faFilePdf}
                                  />
                                  데이터시트
                                </Box>
                              </Link>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Box>
                        {/*==================== 가격정보 리스트 시작=========================*/}
                        <List>
                          {data.price.length > 0
                            ? data.price.map((pics) => (
                                <ListItem className="search-list_provider flex-around">
                                  {/* 로고 및 링크 연결 시작 */}
                                  <Box className="search-list_provider_1st">
                                    {/* 하단 5가지 조건은 search.js 에서 27번째 export const goto 와 일치 한다 */}
                                    {/* 파트너사 -> 컴바인 견적문의하기 */}
                                    {pics.source === "partner" ? (
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          onClick={() =>
                                            combineBotAsked(data, pics)
                                          }
                                        >
                                          {logo(pics)}
                                        </Link>
                                      </Text>
                                    ) : // 판다파츠인데 재고공유인 경우 -> 컴바인 견적문의하기
                                    pics.source === "pandaparts" &&
                                      pics.soldout === 2 ? (
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          onClick={() =>
                                            combineBotAsked(data, pics)
                                          }
                                        >
                                          <img src="/images/brand/logo_partner.png" />
                                        </Link>
                                      </Text>
                                    ) : //  판다파츠인데 백오더인 경우 -> 상품 링크 연결 (백오더 전용 몰뷰)
                                    pics.source === "pandaparts" &&
                                      pics.soldout === 1 ? (
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          href={`/parts/mallview/${pics.it_id}`}
                                        >
                                          {logo(pics)}
                                        </Link>
                                      </Text>
                                    ) : /* 판다파츠가 아닌 경우 인데 재고가 없거나 가격이 없는 경우 -> 컴바인 견적문의하기*/
                                    Number(pics.item_price) === 0 ||
                                      Number(pics.stock) === 0 ? (
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          onClick={() =>
                                            combineBotAsked(data, pics)
                                          }
                                        >
                                          {logo(pics)}
                                        </Link>
                                      </Text>
                                    ) : /* 판다파츠이면서 마켓플레이스가 아닌 경우 판다파츠 파트너스가 나온다 */
                                    pics.source === "pandaparts" &&
                                      pics.isMarketPlace === false ? (
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          href={`/parts/mallview/${pics.it_id}`}
                                        >
                                          {logo(pics)}
                                        </Link>
                                      </Text>
                                    ) : /* 판다파츠이면서 마켓플레이스인 경우 판다파츠 파트너스가 나온다 */
                                    pics.source === "pandaparts" &&
                                      pics.isMarketPlace === true ? (
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          href={`/parts/mallview/${pics.it_id}`}
                                        >
                                          <img src="/images/brand/logo_partner.png" />
                                        </Link>
                                      </Text>
                                    ) : pics.source !== "digikey" &&
                                      data.manufacturer
                                        .toLowerCase()
                                        .includes("analog device") ? (
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          onClick={() =>
                                            combineBotAsked(isLogin, data, pics)
                                          }
                                        >
                                          {logo(pics)}
                                        </Link>
                                      </Text>
                                    ) : (
                                      /* 판다파츠가 아닌 경우 */
                                      <Text
                                        className=" flex-center"
                                        width={100}
                                      >
                                        <Link
                                          href={`/parts/view/PD${pics.stock_no}`}
                                        >
                                          {logo(pics)}
                                        </Link>
                                      </Text>
                                    )}
                                    {/* 로고 및 링크 연결 끝 */}
                                    {/*  바로출고 시작*/}
                                    {/* 판다파츠 이면서 국내 재고인 경우만 바로 출고 표기 */}
                                    {pics.source == "pandaparts" &&
                                    pics.location == "국내" ? (
                                      <Box className="search-list_provider__onday flex-center">
                                        <span>바로출고</span>
                                      </Box>
                                    ) : (
                                      // 바로 출고가 아닌 경우 -> 표시 없음
                                      <Box className="search-list_provider__onday-non" />
                                    )}
                                    {/*  바로출고 끝*/}
                                    {/* 재고 표시 시작 */}
                                    {pics.soldout === 1 ? (
                                      <Text
                                        className=" flex-center"
                                        width={150}
                                      >
                                        재고 0
                                      </Text>
                                    ) : (
                                      // 그 외 기타  -> 보하고 있는 재고 표시
                                      <Text
                                        className=" flex-center"
                                        width={150}
                                      >
                                        재고 {pics.stock.toLocaleString()}
                                      </Text>
                                    )}
                                    {/* 재고 표시 끝 */}
                                    {/* 패키징 시작 */}
                                    <Text
                                      className=" flex-center"
                                      color="gray"
                                      width={150}
                                    >
                                      {pics.packaging}
                                    </Text>
                                  </Box>
                                  {/* 패키징 끝 */}
                                  {/* 상품 가격 시작 */}
                                  <Box className="search-list_provider_2nd">
                                    <Box className="search-list_provider__price">
                                      <Box className="search-list_provider__price-infos">
                                        <Text>
                                          {/* 상품의 moqa */}
                                          {pics.moq.toLocaleString()}개:
                                        </Text>
                                        {/* 파트너사 & 가격이 0 이거나 재고공유인 상품일 경우 -> 견적가로 표기 */}
                                        {(pics.source === "partner" &&
                                          pics.price === 0) ||
                                        pics.soldout === 2 ? (
                                          <Text
                                            textAlign="right!important"
                                            className="search-special"
                                          >
                                            특가제공
                                          </Text>
                                        ) : (
                                          // 그 외 모든 상품인 경우
                                          <Text textAlign="right!important">
                                            {/* ======  item price가 있을 경우 item price 적용 */}
                                            {pics.source == "pandaparts" &&
                                            pics.item_price !== undefined &&
                                            pics.item_price !== 0
                                              ? pics.item_price.toLocaleString()
                                              : pics.price.toLocaleString()}
                                          </Text>
                                        )}
                                      </Box>
                                      {/*  */}
                                      {/* 재고공유 상품인 경우 -> 회원혜택가가 표시 되지 않는다. */}
                                      {pics.soldout === 2 ? (
                                        ""
                                      ) : (
                                        <Box
                                          color="#EE3842"
                                          className="search-list_provider__price-infos"
                                        >
                                          <Text>회원혜택가:</Text>
                                          {pics.source === "partner" &&
                                          pics.hook_price === 0 ? (
                                            <Text textAlign="right!important"></Text>
                                          ) : (
                                            <Text textAlign="right!important">
                                              {/* ======  item price가 있을 경우 item price 적용 */}
                                              {pics.source == "pandaparts" &&
                                              pics.item_price !== undefined &&
                                              pics.item_price !== 0
                                                ? pics.item_hook_price.toLocaleString()
                                                : pics.hook_price.toLocaleString()}
                                            </Text>
                                          )}
                                        </Box>
                                      )}
                                    </Box>
                                    {/* 상품 가격 끝 */}
                                    {/* 상품 위치 시작 */}
                                    <Text className="flex-center" width={150}>
                                      <span
                                        width="30px!important"
                                        padding="0px!important"
                                        margin="0px0px!important"
                                      >
                                        {pics.location}
                                      </span>
                                    </Text>
                                    {/* 상품 위치 끝 */}
                                    {/* 입고날짜 시작 */}
                                    <Box className="search-list_provider_export">
                                      {pics.soldout === 1 ? (
                                        <>
                                          <Text>입고시</Text>
                                          <Text color="#ee3842">출고 예정</Text>
                                        </>
                                      ) : (
                                        <Text> {period(pics)}</Text>
                                      )}
                                    </Box>
                                  </Box>
                                  {/* 입고날짜 끝 */}
                                  {/* 주문버튼 시작 */}
                                  {pics.soldout === 1 ? (
                                    <Link
                                      textAlign="center"
                                      className="search-list_provider_3rd back_order_btn"
                                      href={`/parts/mallview/${pics.it_id}`}
                                    >
                                      Back-Order{" "}
                                    </Link>
                                  ) : pics.soldout === 2 ? (
                                    <Box
                                      textAlign="center"
                                      className="search-list_provider_3rd back_order_btn inventory_btn"
                                      onClick={() =>
                                        combineBotAsked(data, pics)
                                      }
                                    >
                                      컴바인 견적문의{" "}
                                    </Box>
                                  ) : (
                                    <Box
                                      textAlign="center"
                                      className="search-list_provider_3rd"
                                    >
                                      {Goto(pics, data, isLoginCheck, keyword)}
                                    </Box>
                                  )}
                                  {/* 주문버튼 끝 */}
                                </ListItem>
                              ))
                            : ""}
                        </List>
                        {/*==================== 가격정보 리스트 끝=========================*/}
                      </ListItem>
                    ) : (
                      ""
                    )
                  )
                ) : (
                  <Box></Box>
                )}
              </List>
            </Box>
          </Box>
          {/* ============ 검색결과 데이터가 없을때  ============*/}
          <Box className={noneSearchShow ? "search" : "search-hidden"}>
            <Center>
              <Box className="noneSearch">
                <Image className="noneSearch-img" src="/images/warning 1.png" />
                <Text className="noneSearch-result">검색 결과가 없습니다.</Text>
                <Text>부품번호가 정확한지 확인해보세요.</Text>
                <Text>정확하다면 별도의 견적문의를 해보세요 </Text>
                <Link color="#0b83e6" onClick={handleClick}>
                  컴바인봇 견적문의{" "}
                </Link>
              </Box>
            </Center>
          </Box>
          {/* ============ 검색결과 에러가 생길때  ============*/}
          <Box className={searchError ? "search" : "search-hidden"}>
            <Center>
              <Box className="noneSearch">
                <Image className="noneSearch-img" src="/images/warning 1.png" />
                <Text className="noneSearch-result">검색에러</Text>
                <Text>부품번호가 정확한지 확인해보세요.</Text>
                <Text>정확하다면 별도의 견적문의를 해보세요 </Text>
                <Link color="#0b83e6" onClick={handleClick}>
                  컴바인봇 견적문의{" "}
                </Link>
              </Box>
            </Center>
          </Box>
        </Box>
      </BaseLayout>
    </>
  );
}
